import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsConfigRoute: InvariantJiraRoute = {
	name: 'legacy-reports-configure',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey'],
};
